// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import extensionConnectionEntity from './entities/extension-connection.json';
import extensionConnectionMenu from '../pages/extension-connection/menu.json';
import extensionConnectionFullForm from '../pages/extension-connection/forms/full.json';
import extensionConnectionContextForm from '../pages/extension-connection/forms/context.json';
import extensionConnectionMiniForm from '../pages/extension-connection/forms/mini.json';
import extensionConnectionLookupForm from '../pages/extension-connection/forms/lookup.json';
import extensionConnectionTableView from '../pages/extension-connection/views/table.json';
import extensionConnectionCardsView from '../pages/extension-connection/views/cards.json';
import extensionConnectionDashboardView from '../pages/extension-connection/views/dashboard.json';

/** Тип запису «Підключення» зі сторінками пакета: меню, форми та подання з pages/extension-connection/. */
export const extensionConnectionDefinition: IRecordTypeDefinition = {
  ...extensionConnectionEntity,
  views: assembleViewSet({
      table: extensionConnectionTableView,
      cards: extensionConnectionCardsView,
      dashboard: extensionConnectionDashboardView,
  }),
  form: extensionConnectionFullForm,
  forms: { full: extensionConnectionFullForm, context: extensionConnectionContextForm, mini: extensionConnectionMiniForm, lookup: extensionConnectionLookupForm },
  menu: extensionConnectionMenu,
} as IRecordTypeDefinition;
